import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { HomeProject } from '@models/swagger';
import { PostComeroundProjectParams } from './service';

export enum PostComeroundProjectActions {
  Failure = '[Project PostComeroundProject] Failure',
  Request = '[Project PostComeroundProject] Request',
  Success = '[Project PostComeroundProject] Success',
  Reset = '[Project PostComeroundProject] Reset',
}

export const PostComeroundProjectFailure = createAction(
  PostComeroundProjectActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const PostComeroundProjectRequest = createAction(
  PostComeroundProjectActions.Request,
  props<{ body: HomeProject; parameters?: PostComeroundProjectParams }>()
);

export const PostComeroundProjectSuccess = createAction(
  PostComeroundProjectActions.Success,
  props<{ data: HomeProject }>()
);

export const PostComeroundProjectReset = createAction(PostComeroundProjectActions.Reset);
